import React, { useMemo } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { CardProduct } from "../../components/CardProduct";
import { NoticeWrap } from "../../components/NoticeWrap";
import { getCookie } from "../../utils";

export const HomePageProduct = () => {
  const { t } = useTranslation();
  const products = useMemo(() => {
    return [
      {
        fromTag: "sso",
        title: t("homePage.product.product1.title"),
        titleSmall: t("homePage.product.product1.titleSmall"),
        subtitle: t("homePage.product.product1.subtitle"),
        bgimg: "//files.authing.co/authing-website/home-0830-s-3-1-e.png",
        detailUrl: "https://www.authing.cn/learn/sso",
        widthPercent: 4,
      },
      {
        fromTag: "identityautomation",
        title: t("homePage.product.product2.title"),
        titleSmall: t("homePage.product.product2.titleSmall"),
        subtitle: t("homePage.product.product2.subtitle"),
        detailUrl: "/identity-automation",
        trial: true,
      },
      {
        fromTag: "verify",
        title: t("homePage.product.product3.title"),
        titleSmall: t("homePage.product.product3.titleSmall"),
        subtitle: t("homePage.product.product3.subtitle"),
        detailUrl: "https://www.authing.cn/verify",
      },
      {
        fromTag: "gateway-integration",
        title: t("homePage.product.product4.title"),
        titleSmall: t("homePage.product.product4.titleSmall"),
        subtitle: t("homePage.product.product4.subtitle"),
        detailUrl: "https://www.authing.cn/gateway-integration",
      },
      {
        fromTag: "authorization-management",
        title: t("homePage.product.product5.title"),
        titleSmall: t("homePage.product.product5.titleSmall"),
        subtitle: t("homePage.product.product5.subtitle"),
        detailUrl: "https://www.authing.cn/authorization-management",
      },
      {
        fromTag: "guard",
        title: t("homePage.product.product6.title"),
        titleSmall: t("homePage.product.product6.titleSmall"),
        subtitle: t("homePage.product.product6.subtitle"),
        detailUrl: "https://www.authing.cn/learn/guard",
      },
      {
        fromTag: "database-connection",
        title: t("homePage.product.product7.title"),
        titleSmall: t("homePage.product.product7.titleSmall"),
        subtitle: t("homePage.product.product7.subtitle"),
        detailUrl: "https://www.authing.cn/database-connection",
      },
      {
        title: t("homePage.product.product8.title"),
        titleSmall: t("homePage.product.product8.titleSmall"),
        subtitle: t("homePage.product.product8.subtitle"),
        detailUrl: "https://www.authing.cn/apn",
      },
      {
        fromTag: "wechat",
        title: t("homePage.product.product9.title"),
        titleSmall: t("homePage.product.product9.titleSmall"),
        subtitle: t("homePage.product.product9.subtitle"),
        detailUrl: "https://www.authing.cn/mfa",
      },
      {
        fromTag: "mfa",
        title: t("homePage.product.product10.title"),
        titleSmall: t("homePage.product.product10.titleSmall"),
        subtitle: t("homePage.product.product10.subtitle"),
        detailUrl: "https://www.authing.cn/solutions/wechat",
        className: "pc-show",
      },
      // {
      //   title: t("homePage.product.product11.title"),
      //   titleSmall: t("homePage.product.product11.titleSmall"),
      //   subtitle: t("homePage.product.product11.subtitle"),
      //   detailUrl: "https://www.authing.cn/solutions/idaas",
      //   className: "pc-show",
      // },
      {
        fromTag: "multi-tenant",
        title: t("homePage.product.product12.title"),
        titleSmall: t("homePage.product.product12.titleSmall"),
        subtitle: t("homePage.product.product12.subtitle"),
        detailUrl: "/multi-tenant",
        className: "pc-show",
      },
    ];
  }, [t]);

  return (
    <div className={"home-page-product"}>
      <div className={"basic-column"}>
        <div className={"home-page-product-title basic-title"}>
          {t("homePage.product.title")}
        </div>
        <div className={"home-page-product-subtitle"}>
          <div className={"home-api-title-dot"}>
            {t("homePage.api.title-dot-one")}
          </div>
          <NoticeWrap
            noticeList={[
              t("homePage.api.title-dot-one-first"),
              t("homePage.api.title-dot-one-second"),
              t("homePage.api.title-dot-one-third"),
              t("homePage.api.title-dot-one-first"),
            ]}
          />
          <div className={"home-api-title-dot"}>
            {t("homePage.api.title-dot-two")}
          </div>
          <NoticeWrap
            noticeList={[
              t("homePage.api.title-dot-two-first"),
              t("homePage.api.title-dot-two-second"),
              t("homePage.api.title-dot-two-third"),
              t("homePage.api.title-dot-two-first"),
            ]}
          />
          <div className={"home-api-title-dot"}>
            {t("homePage.api.title-dot-three")}
          </div>
          <NoticeWrap
            noticeList={[
              t("homePage.api.title-dot-three-first"),
              t("homePage.api.title-dot-three-second"),
              t("homePage.api.title-dot-three-third"),
              t("homePage.api.title-dot-three-first"),
            ]}
          />
        </div>
        <div className={"home-page-product-warp"}>
          {products.map((item) => {
            return (
              <CardProduct
                mode="dark"
                widthPercent={1}
                {...{
                  ...item,
                  title: item.titleSmall,
                  // Number(getCookie("windowWidth")) > 600
                  //   ? item.title
                  //   : item.titleSmall,
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
